"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upgradeMapToNewest = void 0;
function upgradeMapToNewest(map, useCopy = false) {
    const newMap = useCopy ? JSON.parse(JSON.stringify(map)) : map;
    for (const layer of newMap.layers) {
        updateLayerFieldValue(layer);
    }
    return newMap;
}
exports.upgradeMapToNewest = upgradeMapToNewest;
function updateLayerFieldValue(layer) {
    var _a;
    if (layer.type === 'group') {
        for (const deeperLayer of (_a = layer.layers) !== null && _a !== void 0 ? _a : []) {
            updateLayerFieldValue(deeperLayer);
        }
    }
    if (layer.type === 'objectgroup') {
        for (const obj of layer.objects) {
            if (obj.class === undefined) {
                obj.class = obj.type;
            }
        }
    }
}
//# sourceMappingURL=utility.js.map